import { IntlShape } from 'react-intl';
import getLocalized, { Localized } from '../../locales/Localized';
import { getLocalizedString, getLocalizedStringOrUndefined } from '../../locales';

export type DishId = string;

export interface DishState {
  id: DishId;
  price_zl: number;
  amount?: DishAmount;
  name: Localized<string>;
  description: Localized<string>;
}

export default class Dish {
  private state: DishState;

  constructor(state: DishState) {
    this.state = {
      id: state.id,
      price_zl: state.price_zl,
      ...(state.amount && { amount: state.amount }),
      name: (state.name || {}),
      description: (state.description || {}),
    };
  }

  public static fromState(state: DishState): Dish {
    return new Dish(state);
  }

  public getId(): DishId { return this.state.id; }

  public getPriceZl(): number { return this.state.price_zl; }

  public getAmount(): DishAmount | undefined { return this.state.amount; }

  public getName(locale: string): string | undefined {
    return getLocalized(this.state.name, locale);
  }

  public getDescription(locale: string): string | undefined {
    return getLocalized(this.state.description, locale);
  }

  public getForView(intl: IntlShape): DishForView {
    return new DishForView({
      id: this.state.id,
      price_zl: this.state.price_zl,
      amount: this.state.amount,
      name: getLocalizedString(intl, this.state.name),
      description: getLocalizedStringOrUndefined(intl, this.state.description),
    });
  }
}

interface DishForViewProps {
  id: DishId;
  price_zl: number;
  amount?: DishAmount;
  name: string;
  description?: string;
}

export class DishForView {
  private state: DishForViewProps;

  constructor(props: DishForViewProps) { this.state = { ...props }; }

  public getId(): DishId { return this.state.id; }

  public getName(): string { return this.state.name; }

  public getDescription(): string | undefined { return this.state.description; }

  public getPriceZl(): number { return this.state.price_zl; }

  public getAmount(): DishAmount | undefined { return this.state.amount; }
}

export enum AmountType {
  Grams = 1,
  Milliliters = 2,
  Pieces = 3,
}

interface DishAmount {
  type: AmountType;
  value: number;
}
